export default "/images/6487f82d4b3e51f083c8708a9774f311.avif";